import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BasicBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import {
  BorderProp,
  DesignProp,
  PaddingsProp,
  SizeProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";

export const meta: ComponentMeta = {
  name: "Line",
  version: 1,
  nameI18n: "builder_ui.block_type.line",
  category: [BasicBlock],
  props: {
    width: {
      name: "Width",
      nameI18n: "builder_ui.prop_type.styles.width",
      category: [DesignProp, SizeProp],
      prop: "other",
      type: "slider",
      defaultValue: "100%",
      sliderProps: {
        step: 1,
        max: 1920,
      },
    },
    borderStyle: {
      name: "Border Style",
      nameI18n: "builder_ui.prop_type.styles.border_style",
      category: [DesignProp, BorderProp],
      prop: "other",
      type: "select",
      defaultValue: "solid",
      options: [
        {
          value: "solid",
          label: "Solid",
          labelI18n: "builder_ui.prop_type.styles.border_style_types.solid",
        },
        {
          value: "dashed",
          label: "Dashed",
          labelI18n: "builder_ui.prop_type.styles.border_style_types.dashed",
        },
      ],
    },
    color: {
      name: "Color",
      nameI18n: "builder_ui.prop_type.styles.color",
      category: [DesignProp, BorderProp],
      prop: "other",
      type: "color",
      defaultValue: "var(--theme-website-color-border-primary)",
    },
    borderWidth: {
      name: "Border Width",
      nameI18n: "builder_ui.prop_type.styles.border_width",
      category: [DesignProp, BorderProp],
      prop: "other",
      type: "slider",
      defaultValue: 1,
      sliderProps: {
        units: ["px"],
        step: 1,
        min: 1,
        max: 10,
      },
    },
    paddingY: {
      name: "Top & bottom",
      nameI18n: "builder_ui.prop_type.padding_y",
      category: [DesignProp, PaddingsProp],
      prop: "other",
      type: "slider",
      defaultValue: 0,
      sliderProps: {
        units: ["px", "rem"],
        step: 0.25,
      },
    },
    paddingX: {
      name: "Left & right",
      nameI18n: "builder_ui.prop_type.padding_x",
      category: [DesignProp, PaddingsProp],
      prop: "other",
      type: "slider",
      defaultValue: 0,
      sliderProps: {
        units: ["px", "rem"],
        step: 0.25,
      },
    },
  },
};
